import styled from 'styled-components'
import { getNavPillStyles } from '../style'
import { StyledNavPillProps } from '../type'

const StyledNavPill = styled.div.withConfig({
    shouldForwardProp: (prop) => !['theme'].includes(prop)
})<StyledNavPillProps>(({ theme }) => getNavPillStyles({ theme }))

export default StyledNavPill
